import { render, staticRenderFns } from "./FiltroCupons.vue?vue&type=template&id=55991b5c&"
import script from "./FiltroCupons.vue?vue&type=script&lang=js&"
export * from "./FiltroCupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports